/**
 * Configurator: Plissee nach Mass (Pleated Blinds)
 *
 * Price tables are loaded from assets/plissee-prices.json (CDN-hosted theme asset).
 * To update prices: edit plissee-prices.json in Shopify Admin → Themes → Edit code → Assets.
 *
 * Sections:
 *   1. Helpers         — formatPrice(), snapToBracket(), roundOneDecimal()
 *   2. Config          — read data attributes set by configurator-plissee.liquid
 *   3. Init            — fetch plissee-prices.json, then wire up events
 *   4. Lookup          — lookupPrice(widthCm, heightCm)
 *   5. Bestellmass     — Eingabemass → Produktionsmass (Abzug bei Schrauben)
 *   6. Validate        — validateAll(), min/max applied to Bestellmass
 *   7. Befestigungsart — tile selection, drives hint boxes AND price
 *   8. Menge           — quantity × unit price for the PDP display
 *   9. Cart            — duplicate_plissee.cfm (Bestellmass!), then /cart/add.js
 *  10. Stoffmuster     — sample.cfm handler (not covered by z__jsCalculator.js here)
 */

$(document).ready(function () {

  // ─────────────────────────────────────────────
  // 1. Helpers
  // ─────────────────────────────────────────────

  function formatPrice(amount) {
    // Swiss format: "CHF 1'234.50"
    return 'CHF ' + amount.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'");
  }

  function roundOneDecimal(num) {
    return Math.round(num * 10) / 10;
  }

  /**
   * snapToBracket — index of first bracket >= valueCm.
   * Values below the smallest bracket return 0 (Mindestpreis).
   * Returns -1 if valueCm exceeds the highest bracket (caught by validation).
   */
  function snapToBracket(valueCm, brackets) {
    for (var i = 0; i < brackets.length; i++) {
      if (valueCm <= brackets[i]) return i;
    }
    return -1;
  }

  // ─────────────────────────────────────────────
  // 2. Config
  // ─────────────────────────────────────────────

  var $container = $('[data-plissee-configurator]');

  // Bail out if no plissee configurator on this page
  if ($container.length === 0) return;

  var model         = $container.data('model');
  var priceTableUrl = $container.attr('data-price-table-url');
  var minWidth      = parseFloat($container.attr('data-min-width'));
  var minHeight     = parseFloat($container.attr('data-min-height'));

  // Abzug applied ONLY for Befestigungsart "Schrauben" (Glasleiste).
  // Set via data attributes so the values can be changed without touching JS.
  var abzugBreite = parseFloat($container.attr('data-schrauben-abzug-breite')) || 0;
  var abzugHoehe  = parseFloat($container.attr('data-schrauben-abzug-hoehe'))  || 0;

  var $widthInput        = $('#plissee-breite');
  var $heightInput       = $('#plissee-hoehe');
  var $aufhaengeort      = $('#plissee-aufhaengeort');
  var $widthError        = $('[data-plissee-width-error]');
  var $heightError       = $('[data-plissee-height-error]');
  var $befestigungError  = $('[data-plissee-befestigung-error]');
  var $befestigungTiles  = $('.plissee-befestigung-tile');
  var $hinweise          = $('[data-plissee-hinweis]');
  var $massBox           = $('[data-plissee-bestellmass]');
  var $massWert          = $('[data-plissee-bestellmass-wert]');
  var $addToCart         = $('[data-add-to-cart-trigger]');
  // Price elements are deliberately NOT cached. The theme's price-ui component
  // replaces its .money nodes when the quantity changes, so a cached jQuery
  // object would end up pointing at a detached element and every write would
  // go nowhere visible. Always query fresh.
  var PRICE_UNIT_SEL  = '.purchase-details .price .money';
  var PRICE_TOTAL_SEL = '.purchase-details .modal_price .price .money';
  var PRICE_BOX_SEL   = '.purchase-details .modal_price';

  var selectedBefestigung = '';
  var unitPrice           = null;   // per-item price, before quantity

  // Disable add-to-cart immediately — wait for JSON + valid inputs
  $addToCart.prop('disabled', true);

  function currentQuantity() {
    return parseInt($('.quantityPrice input.quantity-input.quantity-element').val(), 10) || 1;
  }

  // ─────────────────────────────────────────────
  // 3. Init — fetch price table, then wire events
  // ─────────────────────────────────────────────

  $.getJSON(priceTableUrl)
    .done(function (allTables) {
      var priceTable = allTables[model];

      if (!priceTable) {
        console.error('z__jsPlissee: unknown model "' + model + '" in plissee-prices.json');
        return;
      }

      var maxWidth  = priceTable.widths[priceTable.widths.length - 1];
      var maxHeight = priceTable.heights[priceTable.heights.length - 1];

      // Placeholders show the max only. The minimum is a Mindestpreis, not a
      // Mindestmass — snapToBracket() returns bracket 0 for anything smaller,
      // so advertising a minimum here would be misleading.
      $widthInput.attr('placeholder',  'Max. ' + maxWidth  + ' cm');
      $heightInput.attr('placeholder', 'Max. ' + maxHeight + ' cm');

      // ── 4. Lookup ──────────────────────────────────────────────────────────

      function lookupPrice(widthCm, heightCm) {
        var wIdx = snapToBracket(widthCm,  priceTable.widths);
        var hIdx = snapToBracket(heightCm, priceTable.heights);
        if (wIdx === -1 || hIdx === -1) return null;
        return priceTable.prices[hIdx][wIdx];
      }

      // ── 5. Bestellmass ─────────────────────────────────────────────────────

      /**
       * Current Abzug for the selected Befestigungsart.
       * Klemmen: customer measurement is used 1:1.
       * Schrauben (Glasleiste): the production deduction is applied here.
       */
      function currentAbzug() {
        return (selectedBefestigung === 'Schrauben')
          ? { w: abzugBreite, h: abzugHoehe }
          : { w: 0, h: 0 };
      }

      function toOrderDim(inputCm, offset) {
        if (isNaN(inputCm)) return NaN;
        return roundOneDecimal(Math.max(inputCm - offset, 0));
      }

      /** Highest / lowest INPUT the customer may enter for a given limit. */
      function inputLimit(limitCm, offset) {
        return roundOneDecimal(limitCm + offset);
      }

      function renderBestellmass(orderW, orderH) {
        if (!$massBox.length) return;
        var ab = currentAbzug();
        if ((ab.w === 0 && ab.h === 0) || isNaN(orderW) || isNaN(orderH)) {
          $massBox.attr('hidden', 'hidden');
          return;
        }
        $massWert.text(orderW.toFixed(1) + ' x ' + orderH.toFixed(1) + ' cm');
        $massBox.removeAttr('hidden');
      }

      // ── 6. Validate ────────────────────────────────────────────────────────

      function showWidthError(msg)  { $widthError.text(msg).show(); }
      function clearWidthError()    { $widthError.text('').hide(); }
      function showHeightError(msg) { $heightError.text(msg).show(); }
      function clearHeightError()   { $heightError.text('').hide(); }

      /**
       * The theme re-renders the price from the Shopify variant price whenever
       * the quantity changes, replacing the .money nodes in the process.
       * writePrice() therefore re-queries the elements on every call and
       * records what the display should say; the MutationObserver in section 8
       * watches the surrounding container and restores the value if the theme
       * overwrites or re-renders it afterwards.
       */
      var expectedPriceText = null;
      var suppressPriceObserver = false;

      function writePrice(text, unit) {
        suppressPriceObserver = true;

        var $unit  = $(PRICE_UNIT_SEL);
        var $total = $(PRICE_TOTAL_SEL);

        if (unit === null) {
          $unit.removeAttr('data-price');
        } else {
          $unit.attr('data-price', unit);
        }
        $unit.text(text);
        $total.text(text);

        expectedPriceText = text;
        setTimeout(function () { suppressPriceObserver = false; }, 0);
      }

      function renderPrice() {
        if (unitPrice === null) {
          writePrice('–', null);
          return;
        }
        writePrice(formatPrice(unitPrice * currentQuantity()), unitPrice);
      }

      function validateAll() {
        var rawW = parseFloat($widthInput.val());
        var rawH = parseFloat($heightInput.val());
        var widthCm  = isNaN(rawW) ? rawW : roundOneDecimal(rawW);
        var heightCm = isNaN(rawH) ? rawH : roundOneDecimal(rawH);

        var ab      = currentAbzug();
        var orderW  = toOrderDim(widthCm,  ab.w);
        var orderH  = toOrderDim(heightCm, ab.h);

        // Limits apply to the finished blind, so they are converted back into
        // the equivalent input values for the error messages.
        var maxInputW = inputLimit(maxWidth,  ab.w);
        var minInputW = inputLimit(minWidth,  ab.w);
        var maxInputH = inputLimit(maxHeight, ab.h);
        var minInputH = inputLimit(minHeight, ab.h);

        var widthOk  = false;
        var heightOk = false;

        // Width
        if (isNaN(widthCm) || $widthInput.val() === '') {
          clearWidthError();
        } else if (widthCm < minInputW) {
          showWidthError('Mindestbreite: ' + minInputW + ' cm');
        } else if (widthCm > maxInputW) {
          showWidthError('Maximalbreite: ' + maxInputW + ' cm');
        } else {
          clearWidthError();
          widthOk = true;
        }

        // Height
        if (isNaN(heightCm) || $heightInput.val() === '') {
          clearHeightError();
        } else if (heightCm < minInputH) {
          showHeightError('Mindesthöhe: ' + minInputH + ' cm');
        } else if (heightCm > maxInputH) {
          showHeightError('Maximalhöhe: ' + maxInputH + ' cm');
        } else {
          clearHeightError();
          heightOk = true;
        }

        renderBestellmass(widthOk ? orderW : NaN, heightOk ? orderH : NaN);

        // Price depends on the Befestigungsart (via the Abzug), so it is only
        // shown once all three inputs are present.
        if (widthOk && heightOk && selectedBefestigung) {
          unitPrice = lookupPrice(orderW, orderH);
        } else {
          unitPrice = null;
        }
        renderPrice();

        $addToCart.prop('disabled', unitPrice === null);
      }

      // ── 7. Befestigungsart tile selection ──────────────────────────────────

      function renderHinweis() {
        $hinweise.each(function () {
          var art = $(this).attr('data-plissee-hinweis');
          if (art === selectedBefestigung) {
            $(this).removeAttr('hidden');
          } else {
            $(this).attr('hidden', 'hidden');
          }
        });
      }

      $befestigungTiles.on('click', function () {
        $befestigungTiles.removeClass('active');
        $(this).addClass('active');
        selectedBefestigung = $(this).data('value');
        $befestigungError.text('').hide();
        renderHinweis();
        validateAll();
      });

      // ── Wire input events ──────────────────────────────────────────────────

      $widthInput.on('input change',  validateAll);
      $heightInput.on('input change', validateAll);

      function snapInputOnBlur() {
        var raw = parseFloat($(this).val());
        if (!isNaN(raw)) {
          $(this).val(roundOneDecimal(raw));
        }
        validateAll();
      }
      $widthInput.on('blur',  snapInputOnBlur);
      $heightInput.on('blur', snapInputOnBlur);

      // ── 8. Menge ───────────────────────────────────────────────────────────
      // Two layers, because the theme's price-ui component re-renders the price
      // from the Shopify variant price when the quantity changes:
      //   a) delegated handlers recalculate on every quantity interaction
      //   b) a MutationObserver on the CONTAINER restores the value afterwards
      // The observer must watch the container, not the .money element itself:
      // price-ui replaces those nodes, so an observer bound to one of them
      // would be left watching a detached element.

      function reapplyPrice() {
        renderPrice();
        setTimeout(renderPrice, 100);
        setTimeout(renderPrice, 400);
        setTimeout(renderPrice, 800);
      }

      $(document).on(
        'click',
        '.quantityPrice .control, .quantityPrice [data-update-quantity], .quantity-box .control',
        reapplyPrice
      );
      $(document).on(
        'change keyup input',
        '.quantityPrice .quantity-input, input.quantity-input.quantity-element',
        reapplyPrice
      );

      var priceBox = document.querySelector(PRICE_BOX_SEL)
                  || document.querySelector('.purchase-details');

      if (priceBox && window.MutationObserver) {
        new MutationObserver(function () {
          if (suppressPriceObserver || expectedPriceText === null) return;

          var $current = $(PRICE_TOTAL_SEL);
          if ($current.length === 0) $current = $(PRICE_UNIT_SEL);
          if ($current.length === 0) return;

          if ($current.first().text().trim() !== expectedPriceText) {
            writePrice(expectedPriceText, unitPrice);
          }
        }).observe(priceBox, {
          childList:     true,
          characterData: true,
          subtree:       true
        });
      }

      renderHinweis();
      validateAll();

      // ── 9. Cart ────────────────────────────────────────────────────────────

      $addToCart.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if ($addToCart.hasClass('disabled') || $addToCart.prop('disabled')) return;

        // Befestigungsart required
        if (!selectedBefestigung) {
          $befestigungError.text('Bitte Befestigungsart auswählen.').show();
          return;
        }

        var rawW2 = parseFloat($widthInput.val());
        var rawH2 = parseFloat($heightInput.val());
        var inputW = isNaN(rawW2) ? rawW2 : roundOneDecimal(rawW2);
        var inputH = isNaN(rawH2) ? rawH2 : roundOneDecimal(rawH2);

        var ab     = currentAbzug();
        var orderW = toOrderDim(inputW, ab.w);
        var orderH = toOrderDim(inputH, ab.h);

        var wOk = !isNaN(orderW) && orderW >= minWidth  && orderW <= maxWidth;
        var hOk = !isNaN(orderH) && orderH >= minHeight && orderH <= maxHeight;
        if (!wOk || !hOk) {
          validateAll();
          return;
        }

        var price = lookupPrice(orderW, orderH);
        if (price === null) return;

        var aufhaengeort = $.trim($aufhaengeort.val());

        // IMPORTANT: Breite/Hoehe sent to the ERP are the PRODUCTION dimensions
        // (after Abzug). The customer's own measurement is passed separately so
        // support can trace what was entered.
        var productData = {
          pid:                  $('[data-product-id]').data('product-id'),
          productType:          'plissee',
          price:                price,
          title:                $('.vs-product-title').text().trim(),
          Breite:               orderW,
          Hoehe:                orderH,
          BreiteEingabe:        inputW,
          HoeheEingabe:         inputH,
          Befestigungsart:      selectedBefestigung,
          original_product_url: window.location.href
        };

        if (aufhaengeort !== '') {
          productData.Aufhaengeort = aufhaengeort;
        }

        // Disable buttons while loading
        $addToCart.addClass('disabled button_loading');
        $('.fabric-sample > button').addClass('disabled');

        var shopDomain = window.PXUTheme.theme_settings.domain;

        $.ajax({
          type:        'POST',
          url:         'https://apps.vorhingschweiz.com/functions/duplicate_plissee.cfm',
          data:        JSON.stringify(productData),
          contentType: 'application/json',
          dataType:    'json',
          headers:     { 'x-shopify-shop': shopDomain },

          success: function (data) {
            if (data.success !== true) {
              console.error('duplicate_plissee.cfm error', data);
              $addToCart.removeClass('disabled button_loading');
              $('.fabric-sample > button').removeClass('disabled');
              return;
            }

            var cartProperties = {
              'Breite':                inputW  + ' cm',
              'Höhe':                  inputH  + ' cm',
              'Befestigungsart':       selectedBefestigung,
              'Aluminiumfarbe':        'Weiss',
              'Griffe':                'Standard Kunststoff',
              '_original_product_url': productData.original_product_url
            };

            // Only shown when the measurement was actually adjusted, so Klemmen
            // orders stay free of a confusing duplicate line.
            if (orderW !== inputW || orderH !== inputH) {
              cartProperties['Produktionsmass'] = orderW + ' x ' + orderH + ' cm';
            }

            if (aufhaengeort !== '') {
              cartProperties['Aufhängeort'] = aufhaengeort;
            }

            var lieferzeitEl = $('[data-lieferzeit]');
            if (lieferzeitEl.length) {
              var lieferzeitVal = lieferzeitEl.text().trim();
              if (lieferzeitVal) {
                cartProperties['_Lieferzeit'] = lieferzeitVal;
              }
            }

            $.ajax({
              type:     'POST',
              url:      '/cart/add.js',
              dataType: 'json',
              data: {
                items: [{
                  id:         data.vid,
                  quantity:   currentQuantity(),
                  properties: cartProperties
                }]
              },

              success: function () {
                $addToCart.removeClass('button_loading');
                $addToCart.find('svg.checkmark').addClass('checkmark-active');
                window.PXUTheme.jsAjaxCart.updateView();

                setTimeout(function () {
                  $addToCart.find('i, span').hide();
                }, 300);

                setTimeout(function () {
                  $('.header-cart.action-area__link').addClass('show-mini-cart');
                  $addToCart.removeClass('disabled');
                  $('.fabric-sample > button').removeClass('disabled');
                  $addToCart.find('i, span').removeClass('zoomOut').show();
                  $addToCart.find('svg.checkmark').removeClass('checkmark-active');
                }, 2000);
              },

              error: function (xhr) {
                console.error('/cart/add.js error', xhr);
                $addToCart.removeClass('disabled button_loading');
                $('.fabric-sample > button').removeClass('disabled');
              }
            });
          },

          error: function (xhr) {
            console.error('duplicate_plissee.cfm request failed', xhr);
            $addToCart.removeClass('disabled button_loading');
            $('.fabric-sample > button').removeClass('disabled');
          }
        });
      });

    })
    .fail(function (xhr) {
      console.error('z__jsPlissee: failed to load plissee-prices.json', xhr.status, xhr.statusText);
    });

  // ─────────────────────────────────────────────
  // 10. Stoffmuster
  // ─────────────────────────────────────────────
  // z__jsCalculator.js is not loaded for plissees, so the .fabric-sample
  // handler that normally lives there is missing. Without it the button acts
  // as a form submit and adds the plissee itself at its base price.
  // Bound outside the getJSON callback so it also works if the price table
  // fails to load.

  (function () {
    var $sampleBtn = $('.fabric-sample > button');
    if ($sampleBtn.length === 0) return;

    $sampleBtn.on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      if ($sampleBtn.hasClass('disabled')) return;

      $sampleBtn.addClass('disabled button_loading');
      $('[data-add-to-cart-trigger]').addClass('disabled');
      $sampleBtn.find('i, span').addClass('zoomOut');

      function resetSampleBtn() {
        $sampleBtn.removeClass('disabled button_loading');
        $('[data-add-to-cart-trigger]').removeClass('disabled');
        $sampleBtn.find('i, span').removeClass('zoomOut').show();
      }

      $.ajax({
        type:        'POST',
        url:         'https://apps.vorhingschweiz.com/functions/sample.cfm',
        contentType: 'application/json',
        dataType:    'json',
        headers:     { 'x-shopify-shop': window.PXUTheme.theme_settings.domain },
        data: JSON.stringify({
          pid:                  $('[data-product-id]').data('product-id'),
          title:                $('.vs-product-title').text().trim(),
          original_product_url: window.location.href
        }),

        success: function (data) {
          if (!data || data.success !== true) {
            console.error('sample.cfm error', data);
            resetSampleBtn();
            return;
          }

          $.ajax({
            type:     'POST',
            url:      '/cart/add.js',
            dataType: 'json',
            data: {
              items: [{
                id:         data.vid,
                quantity:   1,
                properties: {}
              }]
            },

            success: function () {
              $sampleBtn.removeClass('button_loading').addClass('checkmark-animation');
              $sampleBtn.find('svg').addClass('checkmark-active');
              window.PXUTheme.jsAjaxCart.updateView();

              setTimeout(function () {
                $sampleBtn.removeClass('checkmark-animation');
                $sampleBtn.find('svg').removeClass('checkmark-active');
                resetSampleBtn();
              }, 2000);
            },

            error: function (xhr) {
              console.error('/cart/add.js error (sample)', xhr);
              resetSampleBtn();
            }
          });
        },

        error: function (xhr) {
          console.error('sample.cfm request failed', xhr);
          resetSampleBtn();
        }
      });
    });
  })();

});